export default "__VITE_ASSET__DSNOlkEb__"